// Styles
import { buttonStyles } from "Common/Styles";

const healthCard = { borderRadius: "0.75rem" };

const styles = {
  qrStack: {
    mt: { xs: 1, md: 0 },
    width: { xs: "100%", sm: "fit-content" },
    alignItems: "center",
  },
  dialogPaperProps: {
    paper: {
      sx: {
        borderRadius: "1.6rem",
        backgroundColor: "background.default",
        p: 2.5,
      },
    },
  },
  scanButtonHeader: {
    textAlign: { xs: "center", md: "end" },
    fontSize: { xs: "x-small", md: "small" },
    color: "text.secondary",
  },
  mainActionButton: {
    minWidth: "125px",
  },
  uploadImageInstead: {
    alignSelf: "center",
    backgroundColor: "transparent",
    boxShadow: "none",
    color: "text.secondary",
    textDecoration: "underline",
    fontWeight: "medium",
    p: 0,
    m: 0.5,
    minWidth: "125px",
    "&:hover": {
      backgroundColor: "transparent",
      textDecoration: "underline",
      boxShadow: "none",
    },
  },
  secondaryActionButton: {
    ...buttonStyles.outlineGreenActionButton,
    minWidth: "125px",
  },
  mainText: {
    color: "primary.main",
    fontWeight: "medium",
    fontSize: "x-large",
  },
  scanHelpInstruction: {
    display: "list-item",
  },
  disclaimer: {
    textAlign: "center",
    fontSize: "small",
    color: "text.secondary",
  },
  scanner: (flipCam) => {
    return {
      container: {
        borderRadius: "1.6rem",
      },
      video: {
        transform: flipCam ? "scaleX(-1.0)" : "", // mirror on a user facing webcam, like a laptop
      },
    };
  },
  scannerTargetGrid: {
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    width: "100%",
    height: "100%",
  },
  scannerTarget: {
    border: (theme) => `1px solid ${theme.palette.common.white}`,
    borderRadius: "1.25rem",
    width: { xs: "8rem", md: "10rem" },
    height: { xs: "8rem", md: "10rem" },
  },
  instructionsBox: {
    backgroundColor: "background.paper",
    p: 1,
    borderRadius: "0.625rem",
    boxSizing: "border-box",
  },
  instructionsHeader: {
    fontWeight: "medium",
    fontSize: { xs: "small", md: "medium" },
  },
  summaryBox: {
    ...healthCard,
    backgroundColor: "background.paper",
    width: "16rem",
    mb: "0.9rem",
    mx: "1.6rem",
  },
  healthCardImage: {
    width: "100%",
    height: "auto",
    display: "block",
    objectFit: "cover",
    borderTopLeftRadius: healthCard.borderRadius,
    borderTopRightRadius: healthCard.borderRadius,
  },
  healthCardFieldName: {
    fontSize: "small",
    fontWeight: "medium",
  },
  healthCardField: {
    fontSize: "medium",
    fontWeight: "bold",
  },
  healthCardContent: {
    pb: "0.625rem",
    px: "0.625rem",
    borderRadius: `0px 0px ${healthCard.borderRadius} ${healthCard.borderRadius}`,
    ...healthCard,
  },
  cameraPermissionInstruction: {
    fontSize: "0.9rem",
  },
};

export default styles;
